module.exports = __webpack_public_path__ + "f3880da5f3d47034ba5875c9e483506c.fbx";